/* eslint-disable prettier/prettier */
import ParamsEdit from "./column/ParamsEdit.vue";
import i18n from "@/i18n";
import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js"

export const columns = [
    {
        colId: 'check',
        type: 'Checkbox',
        header: '',
        width: "37px"
    },
      {
        type: 'Text',
        colId: 'id',
        header: '参数ID',
        width: '80px',
      },
      {
        colId: 'name',
        header: '参数名称',
        component: ParamsEdit
      },
      {
        type: 'Text',
        colId: 'describe',
        header: '参数描述',
      },
      {
        type: 'Text',
        colId: 'typeName',
        header: '参数类型',
      },
      {
        type: 'Text',
        colId: 'table_name',
        header: '表名',
      },
      {
        type: 'Text',
        colId: 'sourceName',
        header: '参数来源',
      },
      {
        type: 'Text',
        colId: 'remark',
        header: '参数值备注',
      },
      {
        type: 'Operation',
        colId: 'Operation',
        header: '操作',
        width: '160px',
      },
];

export const pageLength = 10;

export const pageLengthRank = [10, 20, 30, 100];

export const bottomButtons =  [
    {
        id: "del",
        text: i18n.t("zhiji.common.delete"),
        icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px 0px",
        hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px -22px",
    },
];

export const searchFilter = [
    {
      props: {
        name: 'filterFields',
        inline: true,
        subItemLabelPosition: 'left',
      },
      uId: '0',
      cid: 'Form',
      events: [],
      children: [
        {
          props: {
            multiple: true,
            collapseTags: true,
            placeholder: '选择参数来源',
            style: {
              width: '280px',
            },
            options: [
              {
                  label: '客户端参数',
                  value: '0'
              },
              {
                  label: 'API参数',
                  value: '1'
              },
              {
                  label: '数据平台清洗参数',
                  value: '2'
              },
              {
                  label: '自定义参数',
                  value: '3'
              },
            ],
            name: 'source',
          },
          uId: '1',
          cid: 'Elselector',
          events: [],
          children: [],
        },
        {
            props: {
              style: {
              },
              options: [
                {
                  label: '按参数ID',
                  value: 'id',
                },
                {
                  label: '按参数名称',
                  value: 'name',
                },
                {
                  label: '按参数描述',
                  value: 'describe',
                },
                {
                  label: '按表名',
                  value: 'table_name',
                },
              ],
              name: 'param_search',
            },
            uId: '2',
            cid: 'CombinedSearch',
            events: [],
            children: [],
        },
      ],
    },
  ];
